(function () {
  function setActiveButton(buttons, activeValue, attrName) {
    buttons.forEach(function (button) {
      var isActive = button.getAttribute(attrName) === activeValue;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function initSupportVideoCenter(root) {
    var wrappers = root.querySelectorAll('[data-support-video-center]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';

      var list = wrapper.querySelector('[data-video-list]');
      var empty = wrapper.querySelector('[data-video-empty]');
      var count = wrapper.querySelector('[data-video-count]');
      var activeLabel = wrapper.querySelector('[data-video-active-label]');
      var categoryButtons = Array.prototype.slice.call(wrapper.querySelectorAll('[data-video-category]'));
      var cards = Array.prototype.slice.call(wrapper.querySelectorAll('[data-video-card]'));
      var pagination = wrapper.querySelector('[data-video-pagination]');
      var prevPageButton = wrapper.querySelector('[data-video-page-prev]');
      var nextPageButton = wrapper.querySelector('[data-video-page-next]');
      var currentPageText = wrapper.querySelector('[data-video-page-current]');
      var totalPageText = wrapper.querySelector('[data-video-page-total]');
      var pageSizeSelect = wrapper.querySelector('[data-video-page-size]');
      var toolbar = wrapper.querySelector('.support-video-center-section__toolbar');
      var modal = wrapper.querySelector('[data-video-modal]');
      var iframe = wrapper.querySelector('[data-video-iframe]');
      var modalTitle = wrapper.querySelector('[data-video-modal-title]');
      var closeButtons = Array.prototype.slice.call(wrapper.querySelectorAll('[data-video-close]'));

      if (!list || !cards.length) return;

      var activeCategory = wrapper.dataset.defaultCategory || 'all';
      var currentPage = 1;
      var selectedPageSize = 12;
      var pageSizeIsCustom = false;
      var previousOverflow = '';

      function scrollToListStart() {
        var target = wrapper;
        if (!target) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          target.scrollIntoView();
          return;
        }

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      function getCurrentColumns() {
        var desktopColumns = parseInt(wrapper.dataset.columnsDesktop || '3', 10);
        var tabletColumns = parseInt(wrapper.dataset.columnsTablet || '3', 10);
        var mobileColumns = parseInt(wrapper.dataset.columnsMobile || '1', 10);
        if (window.matchMedia('(min-width: 1200px)').matches) {
          return desktopColumns;
        }

        if (window.matchMedia('(min-width: 768px)').matches) {
          return tabletColumns;
        }

        return mobileColumns;
      }

      function getPageSize() {
        var configured = pageSizeSelect ? parseInt(pageSizeSelect.value || String(selectedPageSize), 10) : selectedPageSize;
        var columns = Math.max(1, getCurrentColumns());
        return Math.max(columns, Math.ceil(configured / columns) * columns);
      }

      function getResponsiveDefaultPageSize() {
        var desktopPageSize = parseInt(wrapper.dataset.videosPerPageDesktop || '12', 10);
        var tabletPageSize = parseInt(wrapper.dataset.videosPerPageTablet || '15', 10);
        var mobilePageSize = parseInt(wrapper.dataset.videosPerPageMobile || '6', 10);

        if (window.matchMedia('(min-width: 1200px)').matches) {
          return desktopPageSize;
        }

        if (window.matchMedia('(min-width: 768px)').matches) {
          return tabletPageSize;
        }

        return mobilePageSize;
      }

      function getRoundedPageSize(value) {
        var columns = Math.max(1, getCurrentColumns());
        return Math.max(columns, Math.ceil(value / columns) * columns);
      }

      function updatePageSizeOptions() {
        if (!pageSizeSelect) return;

        var columns = Math.max(1, getCurrentColumns());
        var multipliers = [2, 3, 4, 6, 8];
        var values = [];

        multipliers.forEach(function (multiplier) {
          var candidate = columns * multiplier;
          if (values.indexOf(candidate) === -1) {
            values.push(candidate);
          }
        });

        var defaultRounded = getRoundedPageSize(getResponsiveDefaultPageSize());
        if (values.indexOf(defaultRounded) === -1) {
          values.push(defaultRounded);
        }

        var customRounded = getRoundedPageSize(selectedPageSize || defaultRounded);
        if (pageSizeIsCustom && values.indexOf(customRounded) === -1) {
          values.push(customRounded);
        }

        values.sort(function (a, b) {
          return a - b;
        });

        var nextValue = pageSizeIsCustom ? customRounded : defaultRounded;
        if (values.indexOf(nextValue) === -1) {
          nextValue = values[0];
        }

        pageSizeSelect.innerHTML = '';
        values.forEach(function (value) {
          var option = document.createElement('option');
          option.value = String(value);
          option.textContent = String(value);
          pageSizeSelect.appendChild(option);
        });

        pageSizeSelect.value = String(nextValue);
        selectedPageSize = nextValue;
      }

      function syncDefaultPageSize() {
        if (!pageSizeSelect) return;

        updatePageSizeOptions();

        if (pageSizeIsCustom) {
          return;
        }

        var defaultSize = getRoundedPageSize(getResponsiveDefaultPageSize());
        selectedPageSize = defaultSize;
        pageSizeSelect.value = String(defaultSize);
      }

      function applyFilters() {
        var filtered = cards.filter(function (card) {
          var cardCategory = (card.dataset.category || '').toLowerCase();
          return activeCategory === 'all' || cardCategory === activeCategory;
        });

        var pageSize = getPageSize();

        var totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
        if (currentPage > totalPages) {
          currentPage = totalPages;
        }
        if (currentPage < 1) {
          currentPage = 1;
        }

        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = startIndex + pageSize;
        var visibleCards = filtered.slice(startIndex, endIndex);

        cards.forEach(function (card) {
          card.hidden = true;
        });

        visibleCards.forEach(function (card) {
          card.hidden = false;
          list.appendChild(card);
        });

        if (empty) {
          empty.classList.toggle('is-hidden', filtered.length > 0);
        }

        if (count) {
          count.textContent = String(filtered.length);
        }

        if (pagination) {
          pagination.hidden = filtered.length <= pageSize;
        }

        if (currentPageText) {
          currentPageText.textContent = String(currentPage);
        }

        if (totalPageText) {
          totalPageText.textContent = String(totalPages);
        }

        if (prevPageButton) {
          prevPageButton.disabled = currentPage <= 1;
        }

        if (nextPageButton) {
          nextPageButton.disabled = currentPage >= totalPages;
        }

        if (activeLabel) {
          var matched = categoryButtons.find(function (button) {
            return button.getAttribute('data-category-value') === activeCategory;
          });
          activeLabel.textContent = matched ? matched.textContent.trim() : '';
        }

        setActiveButton(categoryButtons, activeCategory, 'data-category-value');
      }

      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('support-video-center-modal-open');
        document.body.style.overflow = previousOverflow;
        if (iframe) {
          iframe.setAttribute('src', '');
        }
      }

      function openModal(card) {
        if (!modal || !iframe || !card) return;

        var embed = card.getAttribute('data-video-embed');
        var title = card.getAttribute('data-video-title') || '';
        if (!embed) return;

        previousOverflow = document.body.style.overflow;
        iframe.setAttribute('src', embed);
        if (modalTitle) {
          modalTitle.textContent = title;
        }
        modal.hidden = false;
        document.body.classList.add('support-video-center-modal-open');
        document.body.style.overflow = 'hidden';
      }

      categoryButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.getAttribute('data-category-value') || 'all';
          activeCategory = value.toLowerCase();
          currentPage = 1;
          applyFilters();
        });
      });

      if (prevPageButton) {
        prevPageButton.addEventListener('click', function () {
          if (currentPage <= 1) return;
          currentPage -= 1;
          applyFilters();
          scrollToListStart();
        });
      }

      if (nextPageButton) {
        nextPageButton.addEventListener('click', function () {
          currentPage += 1;
          applyFilters();
          scrollToListStart();
        });
      }

      if (pageSizeSelect) {
        syncDefaultPageSize();
        pageSizeSelect.addEventListener('change', function () {
          selectedPageSize = parseInt(pageSizeSelect.value, 10) || selectedPageSize;
          pageSizeIsCustom = true;
          currentPage = 1;
          applyFilters();
          scrollToListStart();
        });
      }

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) {
          window.clearTimeout(resizeTimer);
        }
        resizeTimer = window.setTimeout(function () {
          syncDefaultPageSize();
          applyFilters();
        }, 150);
      });

      cards.forEach(function (card) {
        var trigger = card.querySelector('[data-video-open]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          openModal(card);
        });
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) {
          closeModal();
        }
      });

      applyFilters();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSupportVideoCenter(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initSupportVideoCenter(event.target);
  });
})();
